import { Injectable } from '@angular/core';
import {
  Http, XHRBackend, RequestOptions, RequestOptionsArgs, Request, Response, RequestMethod,
  Headers
} from '@angular/http';
import { Observable } from 'rxjs';
import { AuthenticationService } from '../authentication.service';
import { AppSettings } from '../../app.settings';
import { LoadingService } from './loading.service';

@Injectable()
export class HttpClientService extends Http {
  constructor(
    backend: XHRBackend,
    defaultOptions: RequestOptions,
    private authenticationService: AuthenticationService,
    private loadingService: LoadingService
  ) {
    super(backend, defaultOptions);
  }

  request(url: string | Request, options?: RequestOptionsArgs, disableTryFix = false): Observable<Response> {
    let currentUser: any;
    const urlpr: any = url;
    if (url instanceof Request) {
      currentUser = JSON.parse(localStorage.getItem('currentUser'));
      if (currentUser && currentUser.authToken) {
        url.headers.set('X-Authorization', `Bearer ${currentUser.authToken.token}`);
      } else {
        if (urlpr.url.indexOf('reset') < 0) {
          this.navigateOnAuthFail();
        }
      }

      // headers appended to every request
      if (!url.headers.get('Content-Type')) {
        url.headers.append('Content-Type', 'application/json;charset=UTF-8');
        url.headers.delete('Content-Type');
      }
    }

    // Evita mostrar "spinner" cuando es una llamada de las notificaciones
    
    if (urlpr.url.indexOf('notification') > 0) {
      this.loadingService.disableShowSpinner();
    }
    

    return super.request(url, options).catch((error: Response) => {
      if (!disableTryFix && error.json().exception === 'io.jsonwebtoken.ExpiredJwtException') {
        return this.tryFixAuth(currentUser.refreshToken.token).flatMap(
          (res: any) => {
            res = res.json();

            if (res && res.token) {
              const obj = JSON.parse(localStorage.getItem('currentUser'));
              obj.authToken.token = res.token;
              localStorage.setItem('currentUser', JSON.stringify(obj));
            }

            // retry request
            return this.request(url, options, true);
          }
        );
      }
      if (error.json().exception === 'io.jsonwebtoken.ExpiredJwtException') {
        this.authenticationService.logout();
        return Observable.throw({ error: 'Refresh token expired' });
      }

      return Observable.throw(error);
    }).finally(() => {
      this.loadingService.disableShowSpinner();
    });
  }

  private tryFixAuth(token: string): Observable<Response> {
    return this.refreshToken(token);
  }

  // sends request with refresh_token to get new aToken
  // the request returns only aToken and refresh_token, no gToken
  private refreshToken(token: string): Observable<Response> {

    // is called only when refresh_token is set
    const refreshToken = token;

    // check refresh_token in case it's not checked before
    if ('undefined' === typeof refreshToken || !refreshToken || refreshToken == 'undefined') {
      // there's no refresh_token saved
      return Observable.throw({ error: 'Refresh token is not set' });
    }

    // let currentUser: any = JSON.parse(localStorage.getItem('currentUser'));
    // currentUser.authToken.token = refreshToken;
    // localStorage.setItem('currentUser', JSON.stringify(currentUser));

    // form refresh_token request
    const headers = new Headers();
    headers.append('X-Authorization', `Bearer ${refreshToken}`);
    // headers.append('Content-Type', 'application/json;charset=UTF-8');

    const url = AppSettings.API_ENDPOINT + '/token/refresh';

    // refresh_token request
    return this.request(
      new Request({
        method: RequestMethod.Post,
        url: url,
        headers: headers,
        body: ''
      }),
      null, true);
  }

  // Aux methods

  private navigateOnAuthFail() {
    console.warn('Page is going to be refreshed');
    // redirect to auth is performed after reload by authGuard
    // it's possible to add some warning before reload
    window.location.reload();
  }

  private removeAllTokens() {
    localStorage.removeItem('currentUser');
  }
}



// WEBPACK FOOTER //
// D:/Projects/GitHub/education-ee-web/src/app/services/util/http.client.service.ts